import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import system, { getDisplay } from '../../system';
import Base from '../Base';
const SYSTEM_PROPS = ['backgroundProps', 'borderProps', 'borderRadiusProps', 'colorProps', 'flexParentProps', 'flexProps', 'floatProps', 'heightProps', 'marginProps', 'paddingProps', 'positioningProps', 'textProps', 'widthProps'];
const Flex = /*#__PURE__*/function () {
  const Flex = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      display,
      ...props
    } = _ref;
    const [className, style, rest] = system(props, SYSTEM_PROPS);
    const displayFlexClassName = getDisplay(display);
    return /*#__PURE__*/React.createElement(Base, _extends({
      ref: ref,
      className: cx(displayFlexClassName, className),
      style: style
    }, rest));
  });
  Flex.displayName = 'Flex';
  Flex.identifier = Flex.displayName;
  Flex.clonableProps = SYSTEM_PROPS;
  Flex.defaultProps = {
    display: 'flex'
  };
  return Flex;
}();
export default Flex;